import $ from 'jQuery';

global.$ = global.jQuery = $;
require('slick-carousel');

jQuery(function($){
  let $window = $(window);
  let $html = $("html");
  let $header = $("#header");
  let $naviSwitch = $("#navi_switch");
  let $naviClose = $("#navi_close");
  let $kv = $("#kv");
  let $main = $("#wrapper");
  let $toAbout = $("#to_about");
  let $toEnd = $("#to_end");

  let naviPosAjust = function(){
    let _naviHeihgt = $header.outerHeight();
    $main.css({"margin-top": ""});
    if($window.width() < 751){
      //
    }else{
      $main.css({"margin-top": _naviHeihgt});
    }


  };

  let naviAppear = function(){
    if($header.hasClass("navi-open")){
      $html.removeClass("hide-window");
      $header.removeClass("navi-open");
    }else{
      $html.addClass("hide-window");
      $header.addClass("navi-open");
    }
    return false;
  };

  $toAbout.on("click", function(){
    window.location.href = "../#about";
  });
  $toEnd.on("click", function(){
    window.location.href = "../#end";
  });

  $naviSwitch.on("click", naviAppear);
  $naviClose.on("click", naviAppear);


  let _scrollToTarget = function(event){
    let _target = $(event.currentTarget).attr("href");
    if(_target === "#about" || _target === "#end" ){
      if($header.hasClass("navi-open")){
        $html.removeClass("hide-window");
        $header.removeClass("navi-open");
      }
    }
    let _navHeight = 0;
    let __$target = $(event.currentTarget);
    let __targetHash = __$target.attr("href");

    if(__targetHash === "" || __targetHash.indexOf("#") !== 0){
      return false;
    }
    let __targetOffsetTop = $(__targetHash).offset().top + _navHeight;
    $("html, body").stop().animate({scrollTop: __targetOffsetTop},400);
    return false;
  };
  $(".btn--anchor").on("click", _scrollToTarget);

  let _startPos = 0;
  let _currentPos = 0;
  let naviPosition = function(){
    let _naviHeihgt = $header.outerHeight();
    _currentPos = $window.scrollTop();
    if( _currentPos >= _naviHeihgt){
      if(_startPos < _currentPos){
        if(!$header.hasClass("header-close") && !$html.hasClass("hide-window")){
          $header.addClass("header-close");
        }
      }else{
        if($header.hasClass("header-close")){
          $header.removeClass("header-close");
        }
      }
      _startPos = _currentPos;
    }else{
      if($header.hasClass("header-close")){
        $header.removeClass("header-close");
      }
    }
  };

  let $pageTopBtn = $("#pagetop");
  let allAppearFrag = false;
  let setAnimation = function(){
    let $section = $(".animate-section");
    let sectionLen = $section.length;
    let timing;
    if($window.width() < 751){
      timing = $window.height() - $window.height() / 3;
    }else{
      timing = $window.height() - $window.height() / 3;
    }
    for(let i = 0; i < sectionLen; i++){
      let $target = $($section[i]);

      if($target.offset().top > $window.scrollTop() && $window.scrollTop() + timing > $target.offset().top){
        let $wait = $target.find(".wait");
        $wait.each(function(n){
          $($wait[n]).delay(n * 150).queue(function(){
            $(this).removeClass("wait").addClass('animation');
          });
        });
        if($(".wait").length === 0){
          allAppearFrag = true;
        }
      }
    }
  };
  let PageTotBtnPos = function(){
    let _bottomHeight;
    _bottomHeight = $("footer").offset().top;
    if($window.scrollTop() === 0){
      $pageTopBtn.addClass("pagetop-bottom--hide");
    }else if($window.scrollTop() + $window.height() > _bottomHeight){
      $pageTopBtn.addClass("pagetop-bottom--btn");
    }else{
      $pageTopBtn.removeClass("pagetop-bottom--btn");
      $pageTopBtn.removeClass("pagetop-bottom--hide");
    }
  };

  let KVPosTop = function(){
    if(!$kv) return;
    let _headerHeight = $header.height();
    let _scrollAmount = $window.scrollTop();
    let _kvPosTop = _headerHeight - _scrollAmount;
    if($window.width() < 751){
      $kv.css({"top": 0});
    }else{
      if(_kvPosTop < 0){
        $kv.css({"top": 0});
      }else{
        $kv.css({"top": _kvPosTop + "px"});
      }
    }
  };


  let Resizer = function(){
    naviPosAjust();
    KVPosTop();
  };
  let Scroller = function(){
    PageTotBtnPos();
    setAnimation();
    naviPosition();
    KVPosTop();
  };


  $window.on("resize", Resizer);
  Resizer();
  $window.on("scroll", Scroller);
  Scroller();

  $pageTopBtn.on("click", function(){
    $("html, body").stop().animate({scrollTop: 0},400);
    return false;
  });


  // SLICK
  if($('.mousou-slides').length > 0){
    $('.mousou-slides').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
    });


    if($('#archive_slider').length > 0){
      var _$archive = $('#archive');
      var _$archiveHead = $('#archive_head');
      var _$archiveContent = $('#archive_slider');
      _$archiveContent.stop().slideUp();

      var _ArchiveOpenClose = function(){
        if(_$archiveHead.hasClass('archive--head-open')){
          _$archiveHead.removeClass('archive--head-open');
          _$archiveContent.stop().slideUp(
            300, function(){
              $("html, body").stop().animate({scrollTop: _$archive.offset().top},300);
            }
          );
        }else{
          _$archiveHead.addClass('archive--head-open');
          _$archiveContent.stop().slideDown(
            300, function(){
              $("html, body")
                .stop()
                .animate({scrollTop: _$archive.offset().top - $("header").height()},300);
            }
          );

          $('.mousou-slides').slick("setPosition");
        }
      };

      _$archiveHead.on('click', _ArchiveOpenClose);
    }
  }


});